import { createRequestActions } from '../utils';
import * as inciSubstanceTypes from './inciSubstanceTypes';

export const saveInciSubstances = createRequestActions(inciSubstanceTypes.SAVE_INCI_SUBSTANCE);
